<script setup lang="ts">
import type { Schemas } from '@shopware/api-client/api-types';
import type { Tile } from '~/types/cmsTile';

const props = defineProps<{
    element: Schemas['CmsSlot'];
}>();

const elementConfig = useCmsElementConfig(props.element);
const { getSpecificMedia, getMedia } = useGetMedia();

const headline = elementConfig.getConfigValue('headline');
const mobileTiles = elementConfig.getConfigValue('tileCountMobile');
const desktopTiles = elementConfig.getConfigValue('tileCountDesktop');
const tiles = elementConfig.getConfigValue('tiles') as Tile[];

const mediaIds = computed(() => tiles.map((tile: Tile) => tile.media.value));
const { data: medias } = await getMedia(mediaIds.value);
</script>

<template>
    <h4 class="mt-14 text-xl font-extrabold md:mt-100 md:text-3xl">{{ headline }}</h4>

    <div
        class="mt-4 grid gap-4 md:mt-6"
        :class="{
            'grid-cols-1': mobileTiles === '1',
            'grid-cols-2': mobileTiles === '2',
            'md:grid-cols-4': desktopTiles === '4',
            'md:grid-cols-5': desktopTiles === '5',
            'md:grid-cols-6': desktopTiles === '6',
        }"
    >
        <template
            v-for="(tile, index) in tiles"
            :key="index"
        >
            <SharedInformationTile
                :tile="tile"
                :media="getSpecificMedia(tile.media.value, medias)"
            />
        </template>
    </div>
</template>
